import moment from 'moment';
import _ from 'underscore';

angular.module('am4').controller('calendarCtrl', function(calendarService, $scope, $compile, $timeout, uiCalendarConfig, $stateParams, errorService, Analytics, ngDialog, $rootScope, config) {
    var that = this,
        today = moment(), // static - ES6 would help...
        date = moment(); // variable

    that.facility_id = $stateParams.id;
    that.externalCalendar = false;
    that.googleCalendarId = '';
    // Using '$scope' instead of 'that' due to ui.calendar issues with controllerAs
    $scope.eventSources = [];

    that.getExternalCalendarId = function() {
        calendarService.getExternalCalendarId(that.facility_id)
        .then(function(response) {
            if (response.status === 200 && _.has(response.data, 'google_calendar_id')) {
                that.externalCalendar = true;
                that.googleCalendarId = response.data.google_calendar_id;
            }
        })
        .catch(function(err) {
            that.externalCalendar = false;
            that.googleCalendarId = '';
            if (err.status === 401 && err.data.google_calendar_id) {
                errorService.addError('CAN_NO_LONGER_ACCESS_CALENDAR', err);
                    // need to set these to allow editing of google_calendar_id when access is forbidden
                that.externalCalendar = true;
                that.googleCalendarId = err.data.google_calendar_id;
            }
        });
    };

    that.getCalendarEvents = function() {
        calendarService.getEventsInMonth(date.month(), date.year(), that.facility_id, $scope.fac.data.time_zone)
        .then(function(events) {
            $scope.eventSources[0] = events;
        })
        .catch(popCalendarGetError);
    };
    that.getExternalCalendarId();

    that.getCalendarEvents();

    that.next = function() {
        date.add(1, 'months');
        calendarService.getEventsInMonth(date.month(), date.year(), that.facility_id, $scope.fac.data.time_zone)
        .then(function(events) {
            Analytics.trackEvent('facilityCalendar', 'next', that.facility_id, date.format());

            $scope.eventSources[0] = events;
            uiCalendarConfig.calendars.facilityCalendar.fullCalendar('next');
        })
        .catch(popCalendarGetError);
    };

    that.previous = function() {
        date.subtract(1, 'months');
        calendarService.getEventsInMonth(date.month(), date.year(), that.facility_id, $scope.fac.data.time_zone)
        .then(function(events) {
            Analytics.trackEvent('facilityCalendar', 'previous', that.facility_id, date.format());

            $scope.eventSources[0] = events;
            uiCalendarConfig.calendars.facilityCalendar.fullCalendar('prev');
        })
        .catch(popCalendarGetError);
    };

    that.today = function() {
        if (!date.isSame(today, 'month')) {
            date = moment();
            calendarService.getEventsInMonth(date.month(), date.year(), that.facility_id, $scope.fac.data.time_zone)
            .then(function(events) {
                Analytics.trackEvent('facilityCalendar', 'today', that.facility_id, date.format());

                $scope.eventSources[0] = events;
                uiCalendarConfig.calendars.facilityCalendar.fullCalendar('today');
            })
            .catch(popCalendarGetError);
        } else {
            uiCalendarConfig.calendars.facilityCalendar.fullCalendar('today');
        }
    };

    that.getDate = function() {
        if (uiCalendarConfig.calendars.facilityCalendar &&
            uiCalendarConfig.calendars.facilityCalendar.fullCalendar('getDate').local) {
            return uiCalendarConfig.calendars.facilityCalendar.fullCalendar('getDate').local().toDate();
        }
    };

    this.openGoogleCalendarDialog = function() {
        ngDialog.open({
            template: require('../views/modal/addGoogleCalendarIdDialog.html'),
            plain: true,
            scope: $rootScope.$new(),
            controller: 'googleCalendarIdCtrl',
            controllerAs: 'googleCalendarIdCtrl',
            data: {
                isExternalCalendar: that.externalCalendar,
                googleCalendarId: that.googleCalendarId
            }
        });
    };

    $scope.$on('calendarEvents:update', function(event, eventDate) {
        if (date.isSame(moment(eventDate), 'month')) {
            that.getCalendarEvents();
        }
    });

    $scope.$on('updateCalendar', function() {
        that.getExternalCalendarId();
        that.getCalendarEvents();
    });

    // CALENDAR SETUP

    $scope.uiConfig = {
        editable: true,
        header: false,
        // eventDrop: $scope.alertOnDrop,
        // eventResize: $scope.alertOnResize,
        eventRender: eventRender,
        eventClick: openExternalCalendarEventDialog,
        dayNames: moment.weekdays(),
        dayNamesShort: moment.weekdaysShort(),
        timezone: $scope.fac.data.time_zone
    };

    // Refresh the calendar if the facility's timezone is changed
    $scope.$watch('fac.data.time_zone', function(newVal, oldVal) {
        if (newVal !== oldVal) {
            $scope.uiConfig.timezone = newVal;
            $scope.$emit('calendarEvents:update', date);
        }
    });

    // This is a fix to render the calendar height correctly
    // nothing to see here, move along
    $timeout(function() {
        uiCalendarConfig.calendars.facilityCalendar.fullCalendar('render');
    });

    function openExternalCalendarEventDialog(eventData) {
        if (that.externalCalendar) {
            ngDialog.open({
                template: require('../views/modal/externalCalendarEvent.html'),
                plain: true,
                scope: $rootScope.$new(),
                data: {
                    description: eventData.description,
                    title: eventData.title,
                    startDate: moment(eventData.start).format(config.externalCalendarEventDateFormat),
                    endDate: moment(eventData.end).format(config.externalCalendarEventDateFormat)
                }
            });
        }
    }

    function eventRender(event, element) {
        element.attr({ 'data-cy': 'facilityCalendarEvent-' + event.id });

        // Disabled the event for external calendar for now so that it wont go to error page.
        if (!that.externalCalendar) {
            const attrs = {
                tooltips: true,
                'tooltip-template': event.description.length ? event.description : event.title,
                'tooltip-class': '_full-width' // see the hacky hack in tooltip.scss
            };

            if ($rootScope.userPermissions.indexOf('FACILITY_CALENDAR') > -1) {
                attrs['ui-sref'] = "app.am4.facility.calendar.event({ event_id: '" + event.id + "' })";
            }

            element.attr(attrs);
            $timeout(function() {
                $compile(element)($scope);
            });
        }
    }

    function popCalendarGetError(e) {
        errorService.addError('ERROR_GETTING_CALENDAR_EVENTS', e);
    }
});



// WEBPACK FOOTER //
// ./src/app/controllers/calendarCtrl.js